(function () {
  function shortAddress(address) {
    if (!address) return "";
    return address.slice(0, 6) + "..." + address.slice(-4);
  }

  function stripHex(value) {
    return String(value || "").replace(/^0x/, "");
  }

  function pad64(value) {
    return stripHex(value).toLowerCase().padStart(64, "0");
  }

  function encodeAddress(address) {
    return pad64(address);
  }

  function encodeUint(value) {
    var n = BigInt(value || "0");
    return n.toString(16).padStart(64, "0");
  }

  async function switchChain(chainId) {
    if (!chainId || !window.ethereum || !window.ethereum.request) return;
    var hexChainId = "0x" + Number(chainId).toString(16);
    try {
      await window.ethereum.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: hexChainId }]
      });
    } catch (error) {
      if (error && error.code !== 4902) throw error;
    }
  }

  async function readBalance(config, address) {
    var contract = config.contract;
    var data;

    if (config.standard === "ERC1155") {
      data = "0x00fdd58e" + encodeAddress(address) + encodeUint(config.tokenId);
    } else {
      data = "0x70a08231" + encodeAddress(address);
    }

    var result = await window.ethereum.request({
      method: "eth_call",
      params: [{ to: contract, data: data }, "latest"]
    });

    return BigInt(result || "0x0");
  }

  function setState(root, state, message) {
    root.dataset.gateState = state;
    root.querySelectorAll("[data-ppp-gate-message]").forEach(function (node) {
      node.textContent = message || "";
    });
  }

  function unlock(root, address) {
    root.dataset.unlocked = "true";
    root.querySelectorAll("[data-ppp-gate-wallet]").forEach(function (node) {
      node.textContent = shortAddress(address);
    });
    root.querySelectorAll("[data-ppp-wallet-input]").forEach(function (input) {
      input.value = address;
    });
    setState(root, "unlocked", "NFT保有を確認しました。$PPP専用ページを表示しています。");
  }

  async function connect(root) {
    if (!window.ethereum || !window.ethereum.request) {
      setState(root, "error", "ウォレットが見つかりません。MetaMaskなどのEIP-1193対応ウォレットで開いてください。");
      return;
    }

    var contract = root.dataset.nftContract || "";
    if (!/^0x[a-fA-F0-9]{40}$/.test(contract)) {
      setState(root, "error", "NFTコントラクトアドレスが未設定です。Shopifyテーマ設定に入力してください。");
      return;
    }

    setState(root, "checking", "ウォレット接続とNFT保有を確認しています。");

    try {
      var accounts = await window.ethereum.request({ method: "eth_requestAccounts" });
      var address = accounts && accounts[0];
      if (!address) {
        setState(root, "error", "ウォレットアドレスを取得できませんでした。");
        return;
      }

      await switchChain(root.dataset.chainId);

      var balance = await readBalance({
        contract: contract,
        standard: root.dataset.tokenStandard || "ERC721",
        tokenId: root.dataset.tokenId || "0"
      }, address);

      if (balance > 0n) {
        localStorage.setItem("ppp_gate_wallet_address", address);
        unlock(root, address);
      } else {
        setState(root, "denied", "対象NFTの保有を確認できませんでした。");
      }
    } catch (error) {
      setState(root, "error", "確認に失敗しました。ウォレットの接続先ネットワークと承認状態を確認してください。");
    }
  }

  function boot() {
    document.querySelectorAll("[data-ppp-gate]").forEach(function (root) {
      root.querySelectorAll("[data-ppp-gate-connect]").forEach(function (button) {
        button.addEventListener("click", function () {
          connect(root);
        });
      });
    });
  }

  document.addEventListener("DOMContentLoaded", boot);
})();
